export const MEMBER_ERROR_MESSAGES = {
  INVALID_PASSCODE: "兑换码无效：请检查后重新输入",
  ACCOUNT_FROZEN: "账号冻结：请联系客服处理",
  MEMBER_EXPIRED: "会员过期：请联系客服续费",
  DAILY_LIMIT_REACHED: "今日次数用完：请明日再试",
  CYCLE_LIMIT_REACHED: "额度已用完：暂无法领取，请查看会员权益中的恢复时间",
  ALREADY_REDEEMED: "该主题已经领取过，请前往领取记录查看领取资源内容",
  RESOURCE_NOT_CONFIGURED: "资源未配置：请联系客服",
  SERVICE_ERROR: "服务异常：请稍后重试",
} as const;

export type MemberErrorCode = keyof typeof MEMBER_ERROR_MESSAGES;

export function getMemberErrorMessage(
  code: string | null | undefined,
  fallback = MEMBER_ERROR_MESSAGES.SERVICE_ERROR,
): string {
  if (code && code in MEMBER_ERROR_MESSAGES) {
    return MEMBER_ERROR_MESSAGES[code as MemberErrorCode];
  }
  return fallback;
}
